import isEqual from 'lodash/isEqual'
import contracts from '@/api/modules/contracts'

const getDefaultState = () => {
  return {
    list: [],
    listFilters: {},
    cards: {}
  }
}

const state = getDefaultState()

const actions = {
  fetch (context, { filters = {}, cached = true }) {
    if (cached && context.state.list.length && isEqual(context.state.listFilters, filters)) {
      return Promise.resolve()
    }
    return contracts.fetchCardsList(filters)
      .then(data => context.commit('fetch', { data, filters }))
  },

  fetchCard (context, { slug, cached = true }) {
    if (cached && context.state.cards[slug]) {
      return Promise.resolve()
    }
    return contracts.fetchCard(slug)
      .then(data => context.commit('fetchCard', { data, slug }))
  },

  resetState (context) {
    context.commit('resetState')
  }
}

const mutations = {
  fetch (state, { data, filters }) {
    state.list = data
    state.listFilters = filters
  },

  fetchCard (state, { data, slug }) {
    state.cards = {
      ...state.cards,
      [slug]: data
    }
  },

  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

const getters = {
  getBySlug: ({ cards }) => (slug) => {
    return cards[slug]
  }
}

export default () => ({
  namespaced: true,
  state,
  actions,
  mutations,
  getters
})
